export default (title, html) => `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              line-height: 1.6;
              color: #333;
              max-width: 600px;
              margin: 0 auto;
            }
            .email-container {
              border: 1px solid #ddd;
              border-radius: 5px;
              padding: 20px;
              background-color: #f9f9f9;
            }
            .email-header {
              background-color: #FF553B;
              color: white;
              padding: 15px;
              border-radius: 5px 5px 0 0;
              margin-bottom: 20px;
              text-align: center;
            }
            .form-item {
              margin-bottom: 15px;
              border-bottom: 1px solid #eee;
              padding-bottom: 10px;
            }
            .form-label {
              font-weight: bold;
              color: #555;
            }
            .form-value {
              margin-top: 5px;
            }
            .email-footer {
              margin-top: 20px;
              font-size: 12px;
              text-align: center;
              color: #777;
              border-top: 1px solid #eee;
              padding-top: 15px;
            }
          </style>
        </head>
        <body>
          <div class="email-container">
            <div class="email-header">
              <h4>${title || 'İletişim Formu'}</h4>
            </div>
            <div class="email-content">
                ${html}
            </div>
            <div class="email-footer">
              <p>Bu e-posta ${new Date().toLocaleString()} tarihinde gönderilmiştir.</p>
              <p>${window.location.origin} üzerinden gönderilmiştir.</p>
            </div>
          </div>
        </body>
        </html>
      `
